<template>
	<div id="lodgingExperience" class="pb-5" v-if="experiences.length > 0">
		<p :class="isPhone ? 'merriweather-reg-20 px-3' : 'merriweather-reg-24 px-5'">Pourquoi Hortense a sélectionné ce lieu pour vous ?</p>
		<div class="position-relative" :class="isPhone ? 'px-3' : 'px-5'">
			<div class="row-grid" id="scroller" data-aos="fade-up" data-aos-duration="900">
				<div
					class="col-hub"
					v-for="(exp, index) in this.experiences"
					:key="index"
				>
					<div
						class="card-hub zoom-img-container"
					>
						<img :src="exp.image" :alt="exp.label" class="zoom-img" />
					</div>
					<div class="card-hub-text">
						<p class="raleway-semi-p15 text-uppercase mb-1 text-nowrap">{{ exp.label }}</p>
						<p class="raleway-reg-p15 mb-0" v-html="exp.description"></p>
					</div>
				</div>
			</div>
			<div class="flex-shrink-0 previous-slide-button circle-icon" v-if="isOverflowing && !isPhone" @click="scroll_left">
				<img src="../../images/arrow-left-black.svg" alt="Previous" />
			</div>
			<div class="flex-shrink-0 next-slide-button circle-icon" v-if="isOverflowing && !isPhone" @click="scroll_right">
				<img src="../../images/arrow-right-black.svg" alt="Next" />
			</div>
		</div>
		<div v-if="!lodging.event_lodging" class="privilage-exclusives mt-5" :class="isPhone ? 'row' : 'w-100'">
			<div class="w-100" :class="isPhone ? '' : 'row'">
				<div class="col-12 col-md-3 privilage-border-green">
					<p class="raleway-semi-p15 mb-1 text-uppercase">Privilèges exclusifs</p>
					<p class="raleway-reg-p15 mb-0" :class="isPhone ? 'mb-4' : ''">
						En réservant avec Hortense, vous bénéficiez de privilèges exclusifs en fonction de votre statut.
					</p>
				</div>
				<div class="col-12 col-md-9 privileges-list" v-if="Object.keys(gifts).length > 0">
					<ul :class="isPhone ? 'pl-3 pt-4' : ''">
						<li v-for="(description, gift, index) in gifts" :key="index">
							<span class="raleway-semi-p15 title">{{ gift }} <span v-if="description">:</span></span>
							<span class="raleway-reg-p15 desc" v-if="description">{{ description }}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LodgingExperience',
	props: {
		lodging: Object,
		isPhone: Boolean,
	},
	data() {
		return {
			isOverflowing: false,
		};
	},
	mounted() {
		this.checkOverflow();
		window.addEventListener('resize', this.checkOverflow);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkOverflow);
	},
	computed: {
		experiences() {
			const experienceMap = {
				location_experience: {
					label: 'Emplacement',
					image:
						'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Hortense+a+s%C3%A9lectionn%C3%A9+pour+vous/selection-hortense-emplacement.jpg',
				},
				culinary_experience: {
					label: 'Expérience culinaire',
					image:
						'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Hortense+a+s%C3%A9lectionn%C3%A9+pour+vous/selection-hortense-experience-culinaire.jpg',
				},
				wellbeing_experience: {
					label: 'Expérience bien-être',
					image:
						'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Hortense+a+s%C3%A9lectionn%C3%A9+pour+vous/selection-hortense-experience-bien-etre.jpg',
				},
				kids_friendly_experience: {
					label: 'Expérience kids friendly',
					image:
						'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Hortense+a+s%C3%A9lectionn%C3%A9+pour+vous/selection-hortense-experience-kids-friendly.jpg',
				},
				eco_friendly_experience: {
					label: 'Expérience éco-friendly',
					image:
						'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Hortense+a+s%C3%A9lectionn%C3%A9+pour+vous/selection-hortense-experience-eco-friendly.jpg',
					description: 'Des hôtes engagés en faveur du respect de l’environnement'
				},
				local_experience: {
					label: 'Expérience locale',
					image:
						'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Hortense+a+s%C3%A9lectionn%C3%A9+pour+vous/selection-hortense-experience-locale.jpg',
				},
			};

			const coreKeys = [
				'location_experience',
				'culinary_experience',
				'wellbeing_experience',
				'kids_friendly_experience',
			];

			const lodgingData = this.lodging?.lodging_description || {};
			const addressBook = this.lodging?.address_book || {};

			const activeCore = coreKeys.filter(
				key => lodgingData[key] && lodgingData[key] !== '' && lodgingData[key] !== null && lodgingData[key] !== 'null'
			);

			if (activeCore.length === 0) return null;

			const results = activeCore.map(key => ({
				key,
				...experienceMap[key],
				description: lodgingData[key],
			}));

			results.push({
				key: 'eco_friendly_experience',
				...experienceMap.eco_friendly_experience
			});

			const travelLink = lodgingData.travel_guide_link;
			const addressSlug = addressBook.slug;

			const hasTravelLink =
				travelLink &&
				travelLink !== '' &&
				travelLink !== null &&
				travelLink !== 'null';

			const hasAddressSlug = !!addressSlug;

			if (hasTravelLink || hasAddressSlug) {
				const listItems = [];

				if (hasTravelLink) {
					listItems.push(
						`<li><a href="${travelLink}" target="_blank" style="text-decoration: underline; color: black;">Guide de voyage exclusif</a></li>`
					);
				}

				if (hasAddressSlug) {
					listItems.push(
						`<li><a href="/${addressSlug}" target="_blank" style="text-decoration: underline; color: black;">Carnet d’adresses d’exception</a></li>`
					);
				}

				results.push({
					key: 'local_experience',
					...experienceMap.local_experience,
					description: `<ul class="pl-3 ralewat-medi-p15 mb-0">${listItems.join('')}</ul>`,
				});
			}

			return results;
		},
		gifts() {
			const giftMap = {};
			const seenGifts = new Set();

			this.lodging.green_trotters?.forEach(trotter => {
				trotter.gifts?.forEach(gift => {
					if (!seenGifts.has(gift.name)) {
						seenGifts.add(gift.name.trim());
						giftMap[gift.name] = gift.category_description;
					}
				});
			});
			return giftMap;
		}
	},
	methods: {
		scroll_left() {
      let content = document.querySelector("#scroller");
      content.scrollLeft -= 220;
    },
    scroll_right() {
      let content = document.querySelector("#scroller");
      content.scrollLeft += 220;
    },
		checkOverflow() {
			this.$nextTick(() => {
				const el = this.$el.querySelector('#scroller');
				this.isOverflowing = el.scrollWidth > el.clientWidth;
			});
		}
	},
};
</script>

<style scoped>

#lodgingExperience {
	.lodging-header {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 100%;
	}

  .row-grid {
		display: flex;
		flex-direction: row;
		gap: 13px;
		align-items: start;
		overflow-x: auto;
		padding-top: 20px;
		overflow-y: hidden;
	}

	.col-hub {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 210px;
	}

	.card-hub-text {
		padding-top: 4px;
		width: 100%;
	}

	.card-hub {
		position: relative;
		width: 210px;
		height: 200px;
    
	}

	.card-hub img {
		width: 100%;
		height: 210px;
		object-fit: cover;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40.38%, rgba(0, 0, 0, 0.8) 100%);
		border-radius: 15px;
	}

	.privilage-exclusives {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		padding: 24px 10px 24px 32px;
		gap: 16px;
		height: 147px;
		background: #CFE5DC;

		.privilage-border-green {
			border-right: 1px solid #3B6152;
		}

		.title {
			min-width: 100%;
		}
		
		.desc {
			flex: 1;
		}

		@media (max-width: 600px) {
			.title {
				min-width: 100%;
				margin-bottom: 0.3rem;
			}
		}

	}

	.previous-slide-button {
    position: absolute;
    top: 47%;
    transform: translateY(-50%);
    left: 50px;
    color: #F7F7F7;
  }

  .next-slide-button {
    position: absolute;
    top: 47%;
    transform: translateY(-50%);
    right: 50px;
    color: #F7F7F7;
  }

  .circle-icon {
    width: 44px;
    height: 46px;
    border: 1px solid #F7F7F7;
		background-color: #F7F7F7;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}

@media screen and (max-width: 768px) {
	#lodgingExperience {
		.privilage-exclusives {
			height: auto;
			padding: 25px;

			.privilage-border-green {
				border-bottom: 1px solid #3B6152;
				border-right: none;
			}
		}

		.col-hub {
			width: 220px;
		}

		.card-hub {
			width: 210px;
			height: 185px;
		}
		.card-hub img {
			width: 210px;
			height: 185px;
		}
	}
	
}

.zoom-img-container {
	border-radius: 15px;
}
</style>
